// eslint-disable-next-line import/prefer-default-export
export const constants = {
  ALLOWED_POSTAL_CODES: [],
  DEFAULT_LOCATION: 1,
  DEFAULT_DELIVERY_METHOD: 1,
  DEFAULT_PAYMENT_METHOD: 1,
  DELIVERY_METHOD_TYPE_ONSITE: 1,
  DELIVERY_METHOD_TYPE_DELIVER: 2,
  DELIVERY_METHOD_TYPE_TAKEAWAY: 3,
  DELIVERY_METHOD_TYPE_WOLT: 12,
  DELIVERY_METHOD_ID_ONSITE: 4,
  DELIVERY_METHOD_ID_DELIVER: 2,
  DELIVERY_METHOD_ID_TAKEAWAY: 1,
  PAYMENT_METHOD_TYPE_INPERSON: 0,
  PAYMENT_METHOD_TYPE_VALITOR: 1,
  PAYMENT_METHOD_TYPE_VALITOR_PAGE: 10,
  PAYMENT_METHOD_TYPE_BORGUN: 2,
  PAYMENT_METHOD_TYPE_INVOICE: 100,
  PAYMENT_METHOD_TYPE_INVOICE_INTERNAL: 101,
  PAYMENT_METHOD_TYPE_VERIFONECHECKOUT: 11,
  ORDER_STATUS_UNPAYED: 1,
  PAYMENT_METHOD_ID_VALITORPAGE: 12,
  PAYMENT_METHOD_TYPE_TEYAPAGE: 12,
  PAYMENT_METHOD_ID_AUR: 13,
  SESSION_COOKIE_USER_ID: 'greifinnUserUid',
  SESSION_COOKIE_LOCATION_ID: 'greifinnLocationUid',
};
